import type { PublicIntegrationSnapshot } from '@frontend/context/publicIntegrationTypes';
import {
  resolveServiceUrl,
  tryResolveServiceUrl,
} from '@frontend/config/serviceUrlRegistry';

export interface AdminLink {
  name: string;
  url: string;
  description: string;
  icon: string;
}

export function buildAdminLinks(origin: string, integration: PublicIntegrationSnapshot): AdminLink[] {
  const ncOverride = integration.nextcloudUserOidcLoginPath;
  const ncUrl = ncOverride
    ? `${origin.replace(/\/$/, '')}${ncOverride.startsWith('/') ? ncOverride : `/${ncOverride}`}`
    : resolveServiceUrl('nextcloud', 'sso_entry', origin);

  return [
    {
      name: 'Keycloak Admin',
      url: resolveServiceUrl('keycloak', 'admin', origin),
      description: 'Identity, realms, clients, and SSO policies',
      icon: '🛡️',
    },
    {
      name: 'OpenProject Admin',
      url: resolveServiceUrl('openproject', 'admin', origin),
      description: 'Projects, members, workflows, and permissions',
      icon: '📊',
    },
    {
      name: 'Gitea Admin',
      url:
        tryResolveServiceUrl('gitea', 'sso_entry', origin) ||
        resolveServiceUrl('gitea', 'admin', origin),
      description: 'Repositories, organizations, and system administration',
      icon: '🔧',
    },
    {
      name: 'Woodpecker CI',
      url:
        tryResolveServiceUrl('woodpecker', 'callback', origin) ||
        resolveServiceUrl('woodpecker', 'public', origin),
      description: 'CI/CD pipelines, builds, and automation dashboard',
      icon: '🪵',
    },
    {
      name: 'Nextcloud Admin',
      url: ncUrl,
      description: 'Users, apps, storage, and collaboration settings',
      icon: '☁️',
    },
  ];
}
